module.exports = __webpack_public_path__ + "img/black.2f5e413b.webp";